export default __webpack_public_path__ + "static/media/Snd6.64537583.mp3";